import styles from "./VenuesBookPage.module.scss";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import DaySelect from "../../components/DaySelect/DaySelect";
import moment from "moment";
import VenuesBookTimeRange from "./VenuesBookTimeRange/VenuesBookTimeRange";
import {VenueService} from "../../services/venue.service";
import useAppDispatch from "../../hooks/useAppDispatch";
import {openMessage} from "../../store/notification/notificationSlice";
import {IVenue} from "../../models/Venue";
import VenuesBookItem from "./VenuesBookItem/VenuesBookItem";
import useAppSelector from "../../hooks/useAppSelector";
import {useNavigate} from "react-router-dom";
import VenuesBookBasket from "./VenuesBookBasket/VenuesBookBasket";

const VenuesBookPage = () => {
    const {t} = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const {isAuthorized} = useAppSelector(state => state.profileSlice);

    const [step, setStep] = useState<number>(1);
    const [numberForWeek, setNumberForWeer] = useState<number>(0);
    const dateArray = [
        moment().add(numberForWeek, "days").format(),
        moment().add(1 + numberForWeek, "days").format(),
        moment().add(2 + numberForWeek, "days").format(),
        moment().add(3 + numberForWeek, "days").format(),
        moment().add(4 + numberForWeek, "days").format(),
        moment().add(5 + numberForWeek, "days").format(),
        moment().add(6 + numberForWeek, "days").format()
    ];
    const [currentDate, setCurrentDate] = useState<string>(dateArray[0]);

    const startHours = VenueService.getStartHours();
    const endHours = VenueService.getEndHours();

    const [selectedStartHour, setSelectedStartHour] = useState<{id: number, label: string, startDate: Date}>(startHours[22]);
    const [selectedEndHour, setSelectedEndHour] = useState<{id: number, label: string, endDate: Date}>(endHours[23]);

    const [availableRooms, setAvailableRooms] = useState<IVenue[]>([]);
    const [currentTimeRange, setCurrentTimeRange] = useState<{startDate: string, endDate: string} | null>(null);

    const [basketItems, setBasketItems] = useState<IVenue[]>([]);

    useEffect(() => {
        if (isAuthorized === false) {
            navigate("/venues");
        }
    }, [isAuthorized]);

    const checkAvailability = async () => {
        const startHour = Number(selectedStartHour.label.split(":")[0]);
        const startMinute =  Number(selectedStartHour.label.split(":")[1]);
        const endHour = Number(selectedEndHour.label.split(":")[0]);
        const endMinute =  Number(selectedEndHour.label.split(":")[1]);
        const start = moment(currentDate).set("hours", startHour).set("minutes", startMinute).set("seconds", 0);
        const end = moment(currentDate).set("hours", endHour).set("minutes", endMinute).set("seconds", 0);

        if (moment(start).isAfter(moment(end))) {
            dispatch(openMessage({type: "error", title: t("PleaseEnterTheTimeCorrectly")}));
            return;
        }

        const model = {
            startDate: {timestamp: start.toISOString()},
            endDate: {timestamp: end.toISOString()}
        }

        try {
            const response = await VenueService.getAvailableRoomsByRange(model);
            if (response.data.trainingRooms.length) {
                setAvailableRooms(response.data.trainingRooms);
                setCurrentTimeRange({startDate: response.data.startDate, endDate: response.data.endDate});
                setStep(3);
            } else {
                dispatch(openMessage({title: t("NoRoomsCouldBeFoundForThisTimeAndDate"), type: "error"}));
            }
        } catch (e) {
            dispatch(openMessage({title: t("NoRoomsCouldBeFoundForThisTimeAndDate"), type: "error"}));
        }

    }

    const addItemToBasketById = (id: number) => {
        const isItemExistInBasket = !!basketItems.find(el => el.id === id);
        if (isItemExistInBasket) return;
        const availableItemById = availableRooms.find(el => el.id === id);
        if (availableItemById) setBasketItems([...basketItems, availableItemById]);
    }

    const deleteBasketItemById = (id: number) => {
        const filteredBasket = basketItems.filter(el => el.id !== id);
        setBasketItems([...filteredBasket]);
    }

    return (
        <div className={styles.page}>
            <div className={"container"}>
                {step === 1 ? (
                    <section>
                        <h2 className={styles.stepTitle}><span>{t("Step")}. 0{step}:</span>{t("SelectDate")}</h2>
                        <DaySelect
                            dateArray={dateArray}
                            currentDate={currentDate}
                            setCurrentDate={setCurrentDate}
                            setNumberForWeer={setNumberForWeer}
                            numberForWeek={numberForWeek}
                            additionalFunction={() => setStep(2)}
                        />
                    </section>
                ) : (step === 2) ? (
                    <section>
                        <h2 className={styles.stepTitle}><span>{t("Step")}. 0{step}:</span>{t("SelectTime")}</h2>
                        <VenuesBookTimeRange
                            selectedStartHour={selectedStartHour}
                            setSelectedStartHour={setSelectedStartHour}
                            selectedEndHour={selectedEndHour}
                            setSelectedEndHour={setSelectedEndHour}
                            checkAvailability={checkAvailability}
                        />
                    </section>
                ) : (
                    <section className={styles.wrapper}>
                        <div className={styles.availableRooms}>
                            {
                                availableRooms.map(el => {
                                    return (
                                        <VenuesBookItem
                                            key={el.id}
                                            item={el}
                                            clickOnButton={addItemToBasketById}
                                            timeRange={currentTimeRange}
                                        />
                                    )
                                })
                            }
                        </div>
                        <VenuesBookBasket
                            basketItems={basketItems}
                            deleteBasketItem={deleteBasketItemById}
                            timeRange={currentTimeRange}
                        />
                    </section>
                )}
            </div>
        </div>
    )
}

export default VenuesBookPage;